export {default} from './ClientsSummaryCard.connect';
